import {Component } from '@angular/core';
import { ActivatedRoute } from '@angular/router';
import { environment } from '../../../environments/environment';
import { HttpClient } from "@angular/common/http";
import { take } from 'rxjs/operators';
import { BriefShareableData, BriefQueryData, publicEditProfileUrlDirectory, AcceptMediaTermsData } from 'globals/store/share.data';
import { publicHelpers } from '../../helpers/public-helpers';
import { Performer } from 'globals/store/performers.data';
import { Exhibitor } from 'globals/store/exhibitors.data';
import { SessionItemInfo } from 'globals/store/share.data';
import { JoiResource } from 'globals/store/resources.data';
import { PublicEditProfileInfo } from 'src/app/store/performers.era';
import { BrandingData } from 'globals/store/publish.data';
import { OnsiteSession } from 'globals/store/onsite.data';
import { Attendee } from 'globals/store/attendees.data';
import { BriefViewComponent } from 'src/app/components/entities/briefView.component';
import { BrandingWrapperComponent } from 'src/app/components/branding/branding-wrapper.component';
import { CommonModule } from '@angular/common';

@Component({
    selector: 'share-brief-page',
    template: `
<branding-wrapper 
  [brandingData]="brandingData" 
  [ngClass]="{ noBranding: !brandingData }"
  [style.--sitebackground]="brandingData?.template?.sitebackground || '#ffffff'">
  <div class="loading" *ngIf="!data && !error">loading...</div>
  <div class="error" *ngIf="!!error" [innerHTML]="helpers.strWithBreak(unavailableMessage)"></div>
  <brief-view
    *ngIf="data && !error"
    [publicView]="true"
    [eventTitle]="data.eventTitle"
    [eventId]="data.eventId"
    [mediaTerms]="data.mediaTerms"
    [performer]="performer"
    [exhibitor]="exhibitor"
    [attendee]="attendee"
    [resource]="resource"
    [entity]="performer || exhibitor || resource || attendee"
    [capitalEntity]="data.briefType | titlecase"
    [lowerEntity]="data.briefType"
    [exhibitorSummaries]="data.exhibitorSummaries"
    [shareCode]="id"
    [performers]="data.performers"
    [performerRoles]="data.performerRoles"
    [sponsors]="data.sponsors"
    [sponsorTypes]="data.sponsorTypes"
    [labelMaps]="data.labelMaps"
    [timeline]="data.timeline"
    [venues]="data.venues"
    [timelineNeedsAction]="timelineNeedsAction"
    [workforceContactProfile]="data.workforceContactProfile"
    [workforceContactInactive]="data.workforceContactInactive"
    [addAssetForSessionShareIds]="addAssetForSessionShareIds"
    [briefProgramPublishes]="data.briefProgramPublishes"
    [briefLogisticsViews]="data.briefLogisticsViews"
    [briefOnsiteViews]="data.briefOnsiteViews"
    [briefActions]="data.briefActions"
    [allEntityInformable]="data.allEntitiesEventInformable"
    [singleEntityInformable]="data.singleEntityInformable"
    [showEditProfileButton]="!!editProfileShareUrl && showEditProfile"
    (editProfileUrl)="openEditProfile()"
    (acceptMediaTerms)="acceptMediaTerms($event)"
  >
  </brief-view>
</branding-wrapper>

    `,
    styleUrls: ['share.brief.scss'],
    standalone: true,
    imports: [BrandingWrapperComponent , CommonModule, BriefViewComponent]
})

export class ShareBriefComponent {

    readonly api = `${environment.functionsURL}api/v1`; // NOTE this is pointing to api/v1 not api/app
    id:string;
    data: BriefShareableData;
    baseShareUrl = environment.joi.shareBase
    helpers = publicHelpers
    addAssetForSessionShareIds = {}
    timelineNeedsAction = false
    editProfileShareUrl: string
    showEditProfile = false
    error: string
    performer: Performer
    resource: JoiResource
    exhibitor: Exhibitor
    attendee: Attendee

    mediaTermsAccepted = false;
    useMediaTerms = false
    loading = true;
    unavailableMessage = "The brief is currently not available.\n\nPlease contact the event organiser."
    brandingData: BrandingData

    acceptMediaTerms(termsId: string) {
      const url = `${this.api}/accept-media-terms`
      const data: AcceptMediaTermsData = { id: this.id, type: this.data.briefType, termsId }
      console.log(data)
      this.http.post(url, data).pipe(take(1)).subscribe((message: any) => {
        this.mediaTermsAccepted = !message.error
        console.log({ message, error: message.error, accepted: this.mediaTermsAccepted })
      })

    }

    openAddAssets(sessionId: string) {
      const shareId = this.addAssetForSessionShareIds[sessionId]
      delete this.addAssetForSessionShareIds[sessionId]
      this.helpers.openInNewTab(`${this.baseShareUrl}/asset/${shareId}`)
      this.checkIfTimelineNeedsAction()
    }

    checkIfTimelineNeedsAction() {
      this.timelineNeedsAction = !!Object.keys(this.addAssetForSessionShareIds).length
    }

    openEditProfile() {
      this.helpers.openInNewTab(this.editProfileShareUrl)
      this.editProfileShareUrl = null
    }
    
    loadData(data: BriefShareableData) {
      this.brandingData = data.brandingData
      
      console.log(data)
      this.data = data
      let entity: Performer | JoiResource | Exhibitor | Attendee
      let editProfileInfo: PublicEditProfileInfo 
      switch (data.briefType) {
        case 'performer': {
          entity = data.performer
          this.performer = entity
          editProfileInfo = data.extraShareables.profile[entity.id]
          data.timeline.forEach(singleTimeline => 
            singleTimeline.bricks
              .filter(({ type, includeAddAssetLinkWhenActive }) => type === 'session' && includeAddAssetLinkWhenActive)
              .forEach((session: OnsiteSession) => {
                console.log({ session, assetId: `${session.id}_${id}`, extraShareables: data.extraShareables })
                const info: SessionItemInfo = data.extraShareables.asset[`${session.id}_${id}`]
                if (info && info.status === 'Active' && session.includeAddAssetLinkWhenActive[id]) {
                  this.addAssetForSessionShareIds[session.id] = info.id
              }
          }))
          this.checkIfTimelineNeedsAction()
          break
        }
        case 'exhibitor': {
          entity = data.exhibitor
          this.exhibitor = data.exhibitor
          editProfileInfo = data.extraShareables.exhibitor[entity.id]
          break
        }
        case 'resource': {
          entity = data.resource
          this.resource = data.resource
          editProfileInfo = data.extraShareables.resource[entity.id]
          break
        }
        case 'attendee': {
          entity = data.attendee
          this.attendee = data.attendee
          editProfileInfo = data.extraShareables.attendee[entity.id]
          break
        }
      }
      
      const { id, name } = entity

      if (editProfileInfo) {
        const { code } = editProfileInfo
        this.showEditProfile =  data.briefType === 'performer' ? data.performer.showEditProfileLinkInPerformerBrief : 
                                data.briefType === 'exhibitor' ? data.exhibitor.showEditProfileLinkInBrief :
                                data.briefType === 'attendee' ? data.attendee.showEditProfileLinkInBrief :
                                data.resource.showEditProfileLinkInBrief
        this.editProfileShareUrl = editProfileInfo && editProfileInfo.status === 'Active' ? `${this.baseShareUrl}${publicEditProfileUrlDirectory[data.briefType]}${code}` : null;
      }
      
      document.title = "Brief for " + name;
    }

    constructor( private route:ActivatedRoute, private http:HttpClient ) {
      this.route.params.subscribe(params=>{
        if(!params || !params.hasOwnProperty('id')) {
          this.loading = false;
          document.title = "Brief unavailable";
        } else {
          this.id = params.id;
          this.sharedDownloadBrief(this.id)
        }
        document.title = "loading";
      })
    }

    async sharedDownloadBrief(shareableId) {
      console.log(shareableId)
      const url = `${this.api}/load-brief-data`
      const queryData: BriefQueryData = { shareableId }
      this.http.post(url, queryData).pipe(take(1)).subscribe((data:BriefShareableData) => {
        this.loading = false;
        this.loadData(data)
      }, (response) => {
        this.loading = false;
        console.log({ error: response })
        this.error = response.error
        document.title = "Brief unavailable";
      });
    }

}

